import React from 'react';

interface Props {
  className?: string;
}

export function IconIG(props: Props) {
  const { className = '' } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <circle cx={16} cy={16} r={16} fill="url(#paint0_linear_4626_151242)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1441 5.73438H11.8531C8.48351 5.73438 5.74219 8.4757 5.74219 11.8453V20.1363C5.74219 23.5059 8.48351 26.2472 11.8531 26.2472H20.1441C23.5137 26.2472 26.255 23.5059 26.255 20.1363V11.8453C26.255 8.4757 23.5136 5.73438 20.1441 5.73438ZM24.1916 20.1352C24.1916 22.3705 22.3796 24.1825 20.1443 24.1825H11.8533C9.61804 24.1825 7.80599 22.3705 7.80599 20.1352V11.8442C7.80599 9.60889 9.61804 7.79688 11.8533 7.79688H20.1443C22.3796 7.79688 24.1916 9.60889 24.1916 11.8442V20.1352ZM10.694 15.9876C10.694 13.0623 13.074 10.6823 15.9994 10.6823C18.9247 10.6823 21.3047 13.0622 21.3047 15.9876C21.3047 18.913 18.9247 21.2929 15.9994 21.2929C13.074 21.2929 10.694 18.9129 10.694 15.9876ZM15.997 19.2283C14.2066 19.2283 12.7552 17.7769 12.7552 15.9865C12.7552 14.1962 14.2066 12.7448 15.997 12.7448C17.7874 12.7448 19.2387 14.1962 19.2387 15.9865C19.2387 17.7769 17.7873 19.2283 15.997 19.2283ZM21.3142 11.9957C22.0163 11.9957 22.5855 11.4265 22.5855 10.7244C22.5855 10.0223 22.0163 9.45312 21.3142 9.45312C20.6121 9.45312 20.043 10.0223 20.043 10.7244C20.043 11.4265 20.6121 11.9957 21.3142 11.9957Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4626_151242"
          x1="0.106913"
          y1="-0.0534563"
          x2="4.99603e-07"
          y2="31.9465"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7024C4" />
          <stop offset="0.415461" stopColor="#C21975" />
          <stop offset="0.702206" stopColor="#C74C4D" />
          <stop offset={1} stopColor="#E09B3D" />
        </linearGradient>
      </defs>
    </svg>
  );
}
